$ = require 'jquery'
Storage = require 'lib/storage'
TrelloModel = require 'models/internal/trello-model'
_ = require 'underscore'

module.exports = class LocalStorageModel extends TrelloModel
  destructor: ->
    @disableTabSync()

  # call enableTabSync to update one tab when local storage is updated in another
  enableTabSync: ->
    @_onStorageBound = @_onStorage.bind(this)
    $(window).on 'storage', @_onStorageBound

  disableTabSync: ->
    if @_onStorageBound?
      $(window).off 'storage', @_onStorageBound

  default: ->
    {}

  _onStorage: (ev) ->
    ev = ev.originalEvent
    if ev?.key == @id && ev.oldValue != ev.newValue
      @fetch()
      @onStorage?(ev.originalEvent)

  sync: (method, model, options) ->
    { success } = options
    switch method
      when 'create'
        ### jshint -W027 ###
        throw Error("not implemented")
      when 'read'
        json = model.syncedKeysFromLocalStorage()
        _.defaults(json, @default())
        success?(model, json, options)
      when 'update'
        json = model.toJSON()
        defaultValues = @default()

        delete json.id
        for key, value of json
          if _.isEqual(value, defaultValues[key])
            delete json[key]

        if _.isEmpty(json)
          Storage.unset(model.id)
        else
          Storage.set(model.id, json)
        success?(model, model.toJSON(), options)
      when 'delete'
        Storage.unset(model.id)
        success?(model, null, options)

  syncedKeysFromLocalStorage: ->
    json = Storage.get(@id) ? {}
    return _.pick(json, @syncedKeys)

  syncedKeys: -> true

  toJSON: -> _.pick(@attributes, @syncedKeys)

  _persistUpdate: (params, next) ->
    Storage.set(@id, _.extend(Storage.get(@id) ? @default(), params))
    next?(null, @toJSON())

  toggle: (attr, value) ->
    if @inSet(attr, value)
      @pull(attr, value)
      false
    else
      @addToSet(attr, value)
      true

  inSet: (attr, value) ->
    value in (@get(attr) ? [])

  addToSet: (attr, value) ->
    @save(attr, (@get(attr) ? []).concat(value))

  pull: (attr, value) ->
    @save(attr, _.without((@get(attr) ? []), value))



// WEBPACK FOOTER //
// ./app/scripts/view-models/internal/local-storage-model.coffee